import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import Component from '@glimmer/component';

interface OptionButtonSignature {
  Element: HTMLButtonElement;
  Args: {};
  Blocks: {
    // default: [];
  };
}

export default class OptionButton extends Component<OptionButtonSignature> {
  constructor(owner: unknown, args: OptionButtonSignature['Args']) {
    super(owner, args);
  }
  <template>
    <button type="button" class="px-2 py-1" ...attributes><FaIcon
        @icon="ellipsis-vertical"
      /></button>
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    OptionButton: typeof OptionButton;
  }
}
